import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeletePlanComponent } from './delete-plan.component';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [DeletePlanComponent],
  imports: [
    CommonModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule    
  ],
  entryComponents:[DeletePlanComponent],
  bootstrap:[DeletePlanComponent]  
})
export class DeletePlanModule { }
